import {IApiBusinessProfileProto, space} from "../../../compiled";
import IBusinessLocationProto = space.kenko.proto.IBusinessLocationProto;
import IServiceProto = space.kenko.proto.IServiceProto;
import IPractitionerProto = space.kenko.proto.IPractitionerProto;
import {providerOffersService} from "../../../util/ProviderUtil";

type Props = {
  
  // these potentially filter the list of providers shown...
  locationFilter: IBusinessLocationProto | null | undefined,
  serviceFilter: IServiceProto | undefined,
  
  business: IApiBusinessProfileProto | undefined,
  onSelect: (bio: IPractitionerProto) => void;
}

export const ChoosePractitioner = (props: Props) => {


  return <div style={{display: 'flex', flexDirection: "column", textAlign: 'start'}}>
    <h3>Select Practitioner</h3>

    {props.business?.providers?.map((provider) => {

      console.log(provider.firstName, provider.lastName);
      
      if (props.serviceFilter && !providerOffersService(props.serviceFilter, provider.practitionerId)) {

        console.log(provider, 'not offered');
        return null;
      }
      
      // TODO - location filter for provider...
      
      return <button key={'pr' + provider.practitionerId + 'a'} className={'BookingOverlaySelectable'} onClick={() => {props.onSelect(provider)}}>
        <div><b>{provider.firstName} {provider.lastName}</b></div>
        <div>{provider.jobTitle}</div>
      </button>
    })}
  </div>

}